import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { addDays, addHours } from 'date-fns';
import { Observable, Subject, Subscription } from 'rxjs';
import { BuildingService } from 'src/app/app/building/building.service';
import { Floor } from 'src/app/app/building/floor/floor.model';
import { FloorService } from 'src/app/app/building/floor/floor.service';
import { DictionaryService, DictionaryValues } from 'src/app/dictionary';
import { Animations } from 'src/app/_helpers/animations';
import { customValidators } from 'src/app/_helpers/customValidators';
import { timePickerCustomTheme } from 'src/app/_helpers/timePickerTheme';
import { UserService } from 'src/app/_services';
import { BookingService } from 'src/app/_services/booking.service';
import { Config, ConfigService } from 'src/app/_services/config.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { SpaceService } from 'src/app/_services/space.service';
import { SpaceType } from 'src/app/_types/space-type';
import { SelectDropdownComponent } from '../../select-dropdown/select-dropdown.component';
import { SpaceFilter } from '../space-filter/space-filter.model';
import { SpaceFilterService } from '../space-filter/space-filter.service';
import { SpaceDateFilterModalComponent } from './space-date-filter-modal/space-date-filter-modal.component';
import {
  SpaceDateFilterModel,
  SpaceDateFilterOptions,
} from './space-date-filter.model';
import { SpaceDateFilterService } from './space-date-filter.service';
import { ParkingTimeReservationComponent } from '../parking-time-reservation/parking-time-reservation.component';
import { User } from 'src/app/_models/user.model';
import { preventSwipeToClose } from 'src/app/_helpers/preventSwipeToClose';

@Component({
  selector: 'app-space-date-filter',
  templateUrl: './space-date-filter.component.html',
  styleUrls: ['./space-date-filter.component.scss'],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class SpaceDateFilterComponent implements OnInit, OnDestroy {
  constructor(
    public spaceService: SpaceService,
    private spaceFilterService: SpaceFilterService,
    public translate: TranslateService,
    public bookingServ: BookingService,
    public userService: UserService,
    public p: ThisPlatform,
    public dictionaryServ: DictionaryService,
    public spaceDateFilterService: SpaceDateFilterService,
    public buildingServ: BuildingService,
    public floorServ: FloorService,
    private modalCtrl: ModalController,
    private configServ: ConfigService
  ) {}

  @ViewChild('floorDropdown') dropdown: SelectDropdownComponent;

  @Input() events: Observable<void>;

  private eventsSubscription: Subscription;

  resetButtonsSubject: Subject<void> = new Subject<void>();

  dateFrom: Date = new Date();
  dateTo: Date = addHours(new Date(), 1); //new Date(new Date().setHours(new Date().getHours() + 1));
  maxDate: Date = addHours(new Date(), 24);

  showLoader: boolean;
  form: FormGroup;
  // filterType: string = "me";
  firstNameLastName: string;
  reservationTypesSlidedDown: boolean = true;
  startDate: Date;
  endDate: Date;
  subtype: number;
  subtypeList: DictionaryValues[];
  timeStart: Date = new Date();
  timeEnd: Date = new Date(new Date().setHours(new Date().getHours() + 1));
  timePickerCustomTheme = timePickerCustomTheme;
  isTimeRangeError = false; //Pomocnicze dla walidacji Time Range
  validationError: boolean = false;

  floorListDisabled: boolean = false;
  showOptionsButton: boolean = false;
  floorList: Floor[];

  label = this.translate.instant('SELECT_USER');

  minTime = '6:00 am'; // Do sprawdzenia w Time Picker
  maxTime = '6:00 pm'; // Do sprawdzenia w Time Picker

  minTimeEnd: string = '6:00 am';

  filterDetails: SpaceDateFilterModel = new SpaceDateFilterModel();

  @Input()
  options: SpaceDateFilterOptions;

  @Output() reloadSpaces = new EventEmitter();

  @Output() resetSpaces = new EventEmitter();

  filterButtons = [
    {
      value: 'me',
      key: this.translate.instant('SPACE.BOOK_FOR_ME'),
    },
    {
      value: 'user',
      key: this.translate.instant('SPACE.BOOK_FOR_USER'),
    },
  ];

  spaceParkingTimeBeforeReservation = [];
  limitTimeBeforeBarking: number;
  limitTimer = '23:59';
  limitTimerBeforeReservation: string;

  hasNoLimitBeforeRole: boolean = false;
  reservationForAnotherRole: boolean = false;
  showCarPlate: boolean = false;
  hasDayLimitBeforeRole: boolean = false;

  spaceParkingBookingConfig: Config[] = [];

  @ViewChild('dateStart') dateStartCalendar: ElementRef;

  async ngOnInit() {
    this.spaceParkingBookingConfig = this.configServ.configs.filter((s) => 
      s.key.includes("space_parking_booking_config")
    );

    this.spaceDateFilterService.setTimeForHowLongReservation = false;
    this.spaceDateFilterService.setTimeToReservation = false;

    this.hasNoLimitBeforeRole = this.userService.hasRoles([
      'space.parking.time_reservaton_before_unlimited',
    ]);
    this.reservationForAnotherRole = this.userService.hasRoles([
      'space.parking.reservation_guest_and_other_user',
    ]);
    this.hasDayLimitBeforeRole = this.userService.hasRoles([
      'space.parking.time_reservaton_before_days',
    ]);

    if(this.spaceParkingBookingConfig.length == 0) {
      this.hasNoLimitBeforeRole = true;
      this.hasDayLimitBeforeRole = true;
    }

    this.eventsSubscription = this.eventsSubscription = this.events.subscribe(
      () => this.parentIonViewWillLeave()
    );

    this.options.headerDesktop = this.translate.instant(
      this.options.headerDesktop
    );
    this.options.headerMobile = this.translate.instant(
      this.options.headerMobile
    );
    this.options.searchButtonText = this.translate.instant(
      this.options.searchButtonText
    );

    if (this.options.spaceType == SpaceType.Parking) {
      this.filterButtons.push({
        value: 'guest',
        key: this.translate.instant('SPACE.BOOK_FOR_GUEST'),
      });
      this.spaceDateFilterService.additionalContent = this.userService.userStorage.carPlate;
    }

    this.filterDetails.startDate = this.dateFrom;
    this.filterDetails.endDate = this.dateTo;

    this.showOptionsButton = true;

    this.spaceFilterService.filterDetailsSubject.subscribe(
      (modalFilterDetails) => {
        this.filterDetails.buildings = modalFilterDetails.buildingListId;
        this.filterDetails.floors = modalFilterDetails.floorListId;
        this.filterDetails.subtype = modalFilterDetails.subtype;
        this.filterDetails.equipments = modalFilterDetails.equipmentListId;
        this.emitChange();
      }
    );

    if (this.configServ.configs.length > 0) {
      this.loadLimitTimeBeforeReservation();
    } else {
      this.configServ.loadConfigs().then((v) => {
        this.loadLimitTimeBeforeReservation();
      });
    }

    this.setUpLimitReservation();

    this.initForm();
  }

  initForm() {
    this.form = new FormGroup(
      {
        dateFrom: new FormControl(this.dateFrom, {
          updateOn: 'blur',
        }),
        dateTo: new FormControl(this.dateTo, {
          updateOn: 'blur',
        }),
        user: new FormControl(this.userService.userBasic),
        guest: new FormControl(null, {
          updateOn: 'blur',
        }),
        carPlate: new FormControl(
          this.options?.spaceType === SpaceType.Parking
            ? this.userService.userStorage.carPlate
            : null,
          {
            updateOn: 'blur',
          }
        ),
      },
      customValidators.dateValidator('dateFrom', 'dateTo')
    );

    this.filterDetails.buildings = this.userService.userStorage.idBuilding
      ? [this.userService.userStorage.idBuilding]
      : null;

    this.spaceFilterService.filterDetails.buildingListId = this.userService
      .userStorage.idBuilding
      ? [this.userService.userStorage.idBuilding]
      : null;
  }

  onUserSelected(user) {
    this.resetSpaces.next(null);
    if (user === 'null') {
      this.spaceDateFilterService.guestSelected = false;
      this.label = this.translate.instant('SELECT_USER');
      if (this.options.spaceType == SpaceType.Parking) {
        // this.spaceDateFilterService.additionalContent = null;
        this.form.patchValue({
          carPlate: null,
        });
      }
    } else {
      if (this.options.spaceType == SpaceType.Parking) {
        // this.spaceDateFilterService.additionalContent = user.carPlate;
        this.form.patchValue({
          carPlate: user.carPlate,
        });
      }
      this.spaceDateFilterService.guestSelected = true;
      this.label = '';
    }
  }

  onFilterSubtype(value) {
    if (value == null) {
      this.filterDetails.subtype = null;
    } else {
      this.filterDetails.subtype = value.toString();
    }
  }

  dateTimeChange(date, ifStartDate?, ifTimePicker?) {
    let startDate;
    let endDate;

    if (this.options.spaceType !== SpaceType.Parking) {
      if (!ifTimePicker && ifStartDate) {
        startDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          this.dateFrom.getHours(),
          this.dateFrom.getMinutes()
        );
        endDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          this.dateTo.getHours(),
          this.dateTo.getMinutes()
        );
      } else if (ifTimePicker && ifStartDate) {
        startDate = new Date(
          this.dateFrom.getFullYear(),
          this.dateFrom.getMonth(),
          this.dateFrom.getDate(),
          date.getHours(),
          date.getMinutes()
        );
        endDate = new Date(
          this.dateFrom.getFullYear(),
          this.dateFrom.getMonth(),
          this.dateFrom.getDate(),
          startDate.getHours() + 1,
          startDate.getMinutes()
        );
      } else {
        startDate = this.dateFrom;
        endDate = new Date(
          this.dateFrom.getFullYear(),
          this.dateFrom.getMonth(),
          this.dateFrom.getDate(),
          date.getHours(),
          date.getMinutes()
        );
      }
    } else {
      if (ifStartDate == true) {
        endDate = new Date(date.setHours(date.getHours() + 1));
        startDate = new Date(date.setHours(date.getHours() - 1)); //TODO: Od godziny początku muszę odejmować godzinę, żeby zapytanie generowało się dobrze. Nie wiem czemu tak to działa
      } else {
        startDate = this.dateFrom;
        endDate = date;
      }
    }

    this.dateFrom = startDate;
    this.dateTo = endDate;
    this.maxDate = addHours(startDate, 23);

    this.form.patchValue({
      dateFrom: startDate,
      dateTo: endDate,
    });

    this.filterDetails.startDate = startDate;
    this.filterDetails.endDate = endDate;

    if (!this.form.valid) {
      this.validationError = true;
    }
    this.resetSpaces.next(null);
  }

  onFilterGuestType(target) {
    this.spaceDateFilterService.filterType = target;
    this.userService.userBasic = null;
    this.spaceDateFilterService.guestSelected = false;
    this.label = this.translate.instant('SELECT_USER');

    if (this.options.spaceType == SpaceType.Parking) {
      if (this.spaceDateFilterService.filterType == 'me') {
        // this.spaceDateFilterService.additionalContent = this.userService.userStorage.carPlate;
        this.form.patchValue({
          carPlate: this.userService.userStorage.carPlate,
        });
      } else {
        // this.spaceDateFilterService.additionalContent = null;
        this.form.patchValue({
          carPlate: null,
        });
      }
    }

    this.resetSpaces.next(null);
  }

  onToggleReservationTypes() {
    this.reservationTypesSlidedDown = !this.reservationTypesSlidedDown;
  }

  emitChange() {
    if (this.form.valid) {
      this.validationError = false;
      this.spaceDateFilterService.additionalContent = this.form.controls.carPlate.value;
      this.spaceDateFilterService.firstNameLastName = this.form.controls.guest.value;
      this.reloadSpaces.next(this.filterDetails);
    } else {
      this.validationError = true;
    }
  }

  async showFilter() {
    const modal = await this.modalCtrl.create({
      component: SpaceDateFilterModalComponent,
      componentProps: {
        page: 'room',
        options: this.options,
        spaceType: this.options.spaceType,
      },
      canDismiss: preventSwipeToClose,
      cssClass: 'add-edit-modal mobile-filter__modal-container',
    });
    modal.present();
  }

  parentIonViewWillLeave() {
    this.dateFrom = new Date();
    this.dateTo = addHours(new Date(), 1); //new Date(new Date().setHours(new Date().getHours() + 1));

    this.filterDetails.startDate = this.dateFrom;
    this.filterDetails.endDate = this.dateTo;
    this.filterDetails.buildings = [];
    this.filterDetails.floors = [];

    this.spaceDateFilterService.filterType = null;
    this.spaceDateFilterService.additionalContent = null;
    this.spaceDateFilterService.firstNameLastName = null;

    this.resetButtonsSubject.next();
  }

  ngOnDestroy() {
    this.eventsSubscription?.unsubscribe();
    this.spaceDateFilterService.filterLoadedFloors = [];
    this.spaceDateFilterService = null;
    this.spaceFilterService.filterDetails = new SpaceFilter();
  }

  checkGuest() {
    if (this.form.controls.guest.value.length > 0) {
      this.spaceDateFilterService.guestSelected = true;
      this.label = this.translate.instant('SPACE.CAR_PLATE_INPUT');
    } else {
      this.spaceDateFilterService.guestSelected = false;
      this.label = this.translate.instant('SELECT_USER');
    }
  }

  loadLimitTimeBeforeReservation() {
    this.spaceParkingTimeBeforeReservation = this.configServ.configs.filter(
      (s) => s.key.includes('space_parking_time_before_reservation')
    );

    this.spaceParkingTimeBeforeReservation.forEach((e) => {
      this.limitTimeBeforeBarking = e.value;
    });
  }

  onlimitTimeBeforeReservation() {
    const today = new Date(Date.now());
    
    const hourse = new Date(
      today.getTime() + this.limitTimeBeforeBarking * 60000
    ).getHours();
      
    const minutes = new Date(
      today.getTime() + this.limitTimeBeforeBarking * 60000
    ).getMinutes();

    if(this.hasNoLimitBeforeRole) {
      return;
    }

    if(this.hasDayLimitBeforeRole) {
      return new Date(today.getTime() + this.limitTimeBeforeBarking * 60000);
    }

    this.limitTimerBeforeReservation = hourse + ':' + minutes;
  }

  async chooseTimeForHowLongNeedParking(timeTo: boolean, forHowLong: boolean) {
    const date = new Date();
    const modal = await this.modalCtrl.create({
      component: ParkingTimeReservationComponent,
      animated: true,
      cssClass: 'add-edit-modal',
      componentProps: {
        timeToReservation: timeTo,
        forHowLongReservation: forHowLong,
        startDate: this.dateFrom ? this.dateFrom : date,
      },
    });
    modal.present();

    if (timeTo && !forHowLong) {
      modal.onDidDismiss().then((data) => {
        if (data.data != null || data.data != undefined) {
          this.dateFrom = this.filterDetails.startDate = data.data;

          this.form.patchValue({
            dateFrom: this.dateFrom,
          });

          if (data.data != null) {
            this.chooseTimeForHowLongNeedParking(false, true);
          }
        }
      });
    } else {
      modal.onDidDismiss().then((data) => {
        if (data.data != null || data.data != undefined) {
          this.dateTo = this.filterDetails.endDate = data.data;

          this.form.patchValue({
            dateTo: this.dateTo,
          });

          this.emitChange();
        }
      });
    }
  }

  private setUpLimitReservation() {
    if(this.hasNoLimitBeforeRole) {
      return;
    }

    if(this.hasDayLimitBeforeRole) {
      return;
    }

    this.onlimitTimeBeforeReservation();
    if (this.p.renderMobile && this.options.spaceType == SpaceType.Parking) {
      this.chooseTimeForHowLongNeedParking(true, false);
    }
  }
}
